export const environment = {
  production: false,
  backendBaseUrl: 'https://sandbox.api.alef-center.com',
  backendApiUrl: 'https://sandbox.api.alef-center.com/api',
  frontendUrl: 'https://sandbox.admin.alef-center.com',
  paymentSystem: 'yaad',
  childrenApiMode: 'adminByParentPath' as const,
};
